module.exports = __webpack_public_path__ + "static/media/linkedIn.94db7e92.png";